var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',[_c('v-text-field',{attrs:{"id":"field","rules":[_vm.rules.required, _vm.rules.name],"label":"Add New","append-icon":"mdi-plus"},on:{"click:append":function($event){return _vm.handleInput(_vm.newVal)}},model:{value:(_vm.newVal),callback:function ($$v) {_vm.newVal=$$v},expression:"newVal"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }